// extracted by mini-css-extract-plugin
module.exports = {"footerLink":"FooterLink_footerLink__h7OxX"};